export default ['hr_employee', 'hr_contract_type', 'hr_contract_period']
